import { render } from "./AttributeView.vue?vue&type=template&id=8328f53a&scoped=true"
import script from "./AttributeView.vue?vue&type=script&lang=js"
export * from "./AttributeView.vue?vue&type=script&lang=js"

import "./AttributeView.vue?vue&type=style&index=0&id=8328f53a&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8328f53a"]])

export default __exports__